module.exports = __webpack_public_path__ + "static/image/logo-family/logo_store.png?41ef6e7f";